<template>
    <basic-container>
        <!-- HVAC 套餐管理页面主容器 -->
        <div class="hvac-package-container">
            <!-- 搜索条件区域 -->
            <div class="search-container">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="二维码名称：">
                        <el-input v-model="searchForm.name" placeholder="请输入" clearable
                            @keyup.enter.native="handleSearch" style="width: 200px" />
                    </el-form-item>
                    <el-form-item label="状态：">
                        <el-select v-model="searchForm.status" placeholder="" clearable style="width: 120px">
                            <el-option label="启用" value="2" />
                            <el-option label="停用" value="1" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="text" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                        <el-button type="text" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="action-container">
                <!-- <el-button type="text" icon="el-icon-printer" :disabled="!selectedRowKeys.length"
                    @click="handleGenerateQrCode">
                    生成二维码
                </el-button> -->
                <!-- 删除按钮 -->
                <el-button type="text" icon="el-icon-delete" :disabled="!selectedRowKeys.length"
                    @click="handleDelete">
                    删除
                </el-button>
            </div>
            <!-- 套餐列表表格区域 -->
            <div class="table-container">
                <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange"
                    v-loading="loading" border>
                    <el-table-column type="selection" min-width="55" />
                    <el-table-column prop="name" label="二维码名称" min-width="180">
                        <template slot-scope="scope">
                            <span class="package-name-link" @click="handleViewPackageDetail(scope.row)">
                                {{ scope.row.name }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="状态" min-width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.status === 1" type="danger">停用</el-tag>
                            <el-tag v-else type="success">启用</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createBy" label="创建人" min-width="100" />
                    <el-table-column prop="createTime" label="创建时间" min-width="180" />
                    <el-table-column label="操作" min-width="200" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.status === 2" type="text" icon="el-icon-close" size="mini"
                                @click="handleDisable(scope.row)">
                                停用
                            </el-button>
                            <el-button v-else type="text" icon="el-icon-check" size="mini"
                                @click="handleEnable(scope.row)">
                                启用
                            </el-button>
                            <el-button type="text" icon="el-icon-edit" size="mini"
                                @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button type="text" icon="el-icon-delete" size="mini"
                                @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页组件区域 -->
            <div class="pagination-container">
                <el-pagination background layout="prev, pager, next, jumper" :total="total"
                    :current-page.sync="currentPage" :page-size.sync="pageSize" @current-change="handleCurrentChange" />
            </div>
            <!-- 查看详情弹窗 - 显示套餐的只读信息 -->
            <el-dialog title="套餐详情" :visible.sync="detailDialogVisible" min-width="50%" :close-on-click-modal="false">
                <el-form :model="currentPackage" label-width="120px">
                    <el-form-item label="二维码名称">
                        <el-input v-model="currentPackage.name" disabled />
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-input :value="currentPackage.status === 1 ? '停用' : '启用'" disabled />
                    </el-form-item>
                    <el-form-item label="创建人">
                        <el-input v-model="currentPackage.createBy" disabled />
                    </el-form-item>
                    <el-form-item label="创建时间">
                        <el-input v-model="currentPackage.createTime" disabled />
                    </el-form-item>
                    <!-- 其他详情字段 -->
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-close" @click="detailDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>
            <!-- 二维码展示弹窗 -->
            <el-dialog title="二维码" :visible.sync="qrCodeDialogVisible" width="400px" :close-on-click-modal="false">
                <div class="qr-code-container">
                    <div v-if="qrCodeDialogVisible" class="qr-code-image" ref="qrcodeContainer"></div>
                    <div v-else class="qr-code-loading">加载中...</div>
                    <p class="qr-code-tip">{{ qrCodeName }}</p>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-download" @click="handleDownloadQrCode">下载二维码</el-button>
                    <!-- <el-button type="text" icon="el-icon-download" @click="handleOpenQrCodeInNewTab">下载二维码</el-button> -->
                    <el-button type="text" icon="el-icon-close" @click="qrCodeDialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>
            <!-- 编辑弹窗 - 用于修改现有套餐信息 -->
            <el-dialog title="编辑套餐" :visible.sync="editDialogVisible" min-width="50%" :close-on-click-modal="false"
                @close="handleEditDialogClose">
                <el-form :model="editForm" :rules="rules" ref="editFormRef" label-width="120px">
                    <el-form-item label="二维码名称" prop="name">
                        <el-input v-model="editForm.name" maxlength="50" show-word-limit />
                    </el-form-item>
                    <!-- 文件表格展示 -->
                    <el-form-item label="套餐信息" v-if="editForm.comboList && editForm.comboList.length > 0">
                        <el-table :data="editForm.comboList" style="width: 100%" border>
                            <el-table-column prop="comboName" label="套餐名称" min-width="200"></el-table-column>
                            <el-table-column label="排序" min-width="150">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.sort" :min="1" :max="9999" :step="1"
                                        @change="handleSortChange(scope.row, scope.$index)"
                                        size="small"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" min-width="100">
                                <template slot-scope="scope">
                                    <el-button type="text" size="mini" icon="el-icon-delete"
                                        @click="handleDeleteEditFile(scope.row, scope.$index)">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="text" icon="el-icon-plus" @click="handleAddPackage">新增套餐</el-button>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-circle-close" @click="handleEditDialogClose">取消</el-button>
                    <el-button type="text" icon="el-icon-circle-check" @click="submitEdit">确定</el-button>
                </span>
            </el-dialog>
            <!-- 新增套餐选择弹窗 -->
            <el-dialog title="选择套餐" :visible.sync="addDialogVisible" min-width="50%" :close-on-click-modal="false">
                <el-select v-model="addForm.comboIds" multiple placeholder="请选择套餐" style="width: 100%">
                    <el-option v-for="item in packageList" :key="item.id" :label="item.name" :value="item.id"
                        :disabled="editForm.comboList.some(combo => combo.comboId === item.id)" />
                </el-select>
                <span slot="footer" class="dialog-footer">
                    <el-button type="text" icon="el-icon-circle-close" @click="handleCancelAddPackage">取消</el-button>
                    <el-button type="text" icon="el-icon-circle-check" @click="handleConfirmAddPackage">确定</el-button>
                </span>
            </el-dialog>
        </div>
    </basic-container>
</template>
<script>
import QRCode from 'qrcode'
import {
    getQrCodeList,
    getQrCodeDetail,
    updateQrCode,
    deleteQrCode,
    startOrStopQrCode,
    getHvacPackageList,
    generateHvacPackageQrCode
} from '@/api/salesCloud/hvacPackage'
import FileUpload from './components/fileUpload'
// HVAC 套餐管理组件
export default {
    name: 'HvacPackage',
    components: {
        FileUpload
    },
    // 组件数据
    data() {
        return {
            searchForm: {
                name: '',
                status: ''
            },
            tableData: [],
            packageList: [], // 可选套餐列表
            loading: false,
            total: 0,
            currentPage: 1,
            pageSize: 10,
            selectedRowKeys: [],
            selectedRows: [],
            detailDialogVisible: false,
            editDialogVisible: false,
            addDialogVisible: false,
            qrCodeDialogVisible: false,
            currentPackage: {},
            editForm: {
                name: '',
                images: [],
                type: 'package', // 'package' 或 'vr'
                comboList: [], // 用于存储导入的文件列表
                vrUrl: '' // VR地址
            },
            addForm: {
                name: '',
                images: [],
                type: 'package', // 'package' 或 'vr'
                comboList: [], // 用于存储导入的文件列表
                comboIds: [], // 用于存储选中的套餐ID
                vrUrl: '' // VR地址
            },
            qrCodeUrl: '',
            qrCodeName: '二维码', // 二维码名称
            rules: {
                name: [
                    { required: true, message: '请输入二维码名称', trigger: 'blur' },
                    { max: 50, message: '二维码名称不能超过50个字符', trigger: 'blur' }
                ],
                vrUrl: [
                    { required: false, validator: this.validateVrUrl, trigger: ['blur', 'change'] }
                ],
                comboList: [
                    { required: false, validator: this.validateFiles, trigger: 'change' }
                ]
            },
            qrCodeRules: {
                qrCodeName: [
                    { required: true, message: '请输入二维码名称', trigger: 'blur' },
                    { max: 50, message: '二维码名称不能超过50个字符', trigger: 'blur' }
                ]
            },
        }
    },
    created() {
        this.loadData()
    },
    /**
         * 组件方法集合
         */
    methods: {
        handleAddPackage() {
            this.addDialogVisible = true
        },
        handleEditDialogClose() {
            this.editDialogVisible = false
        },
        /**
         * 处理二维码弹窗关闭
         * @description 关闭二维码弹窗并重置二维码名称和清理二维码实例
         */
        handleQrCodeDialogClose() {
            this.qrCodeDialogVisible = false
            this.qrCodeName = '二维码' // 重置为默认值
            this.qrCodeUrl = '' // 清空二维码URL
            // 清理二维码容器内容，避免重复生成
            if (this.$refs.qrcodeContainer) {
                this.$refs.qrcodeContainer.innerHTML = ''
            }
        },
        /**
         * 打开二维码弹窗
         * @description 打开展示二维码的弹窗
         */
        handleGenerateQrCode() {
            this.qrCodeUrl = '' // 清空之前的二维码
            this.qrCodeDialogVisible = true
        },
        /**
         * 确认生成二维码
         * @description 验证二维码名称并生成二维码
         * @returns {Promise<void>}
         */
        async handleGenerateQrCodeConfirm() {
            // 验证二维码名称
            const valid = await this.$refs.qrCodeFormRef.validate();
            if (valid) {
                try {
                    // 构建请求数据结构
                    const params = {
                        name: this.qrCodeName,
                        comboList: this.selectedRows.map(row => ({ comboId: row.id }))
                    };
                    const res = await generateHvacPackageQrCode(params)
                    if (res.code == 200) {
                        this.$message.success('二维码生成成功')
                        this.qrCodeDialogVisible = false
                    } else {
                        this.$message.error(res.msg || '生成二维码失败')
                    }
                } catch (error) {
                    this.$message.error('生成二维码失败')
                }
            }
        },
        /**
         * 验证VR地址
         */
        validateVrUrl(rule, value, callback) {
            // 只有在VR类型且没有输入VR地址时才验证
            if (this.addForm.type === 'vr' && (!value || value.trim() === '')) {
                callback(new Error('请输入VR地址'))
            } else {
                callback()
            }
        },
        /**
         * 验证文件列表
         */
        validateFiles(rule, value, callback) {
            // 对于套餐类型，可以有图片或PDF文件，至少需要一种
            if (this.addForm.type === 'package' && this.addForm.comboList.length === 0) {
                callback(new Error('请至少上传一张图片或一个PDF文件'))
            } else {
                callback()
            }
        },
        /**
         * 加载套餐列表数据
         * @description 根据搜索条件和分页信息从服务器获取套餐列表
         * @returns {Promise<void>}
         */
        async loadData() {
            this.loading = true
            try {
                const params = {
                    page: this.currentPage,
                    size: this.pageSize,
                    name: this.searchForm.name,
                    status: this.searchForm.status
                }
                const res = await getQrCodeList(params)
                // const 可选套餐列表调用
                const packageResParams = {
                    status: 2
                }
                const packageRes = await getHvacPackageList(packageResParams)
                this.packageList = JSON.parse(packageRes.data).rows
                this.tableData = JSON.parse(res.data).rows
                this.total = JSON.parse(res.data).total
            } catch (error) {
                this.$message.error('获取套餐列表失败')
            } finally {
                this.loading = false
            }
        },
        /**
           * 处理搜索操作
           * @description 根据当前搜索条件重新加载数据，重置为第一页
           */
        handleSearch() {
            this.currentPage = 1
            this.loadData()
        },
        /**
           * 重置搜索条件
           * @description 清空所有搜索条件并重新加载数据
           */
        resetSearch() {
            this.searchForm = {
                name: '',
                status: ''
            }
            this.currentPage = 1
            this.loadData()
        },
        /**
           * 处理分页变化
           * @description 当用户切换页码时触发，加载对应页的数据
           * @param {number} currentPage - 当前页码
           */
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.loadData()
        },
        /**
           * 处理表格复选框选择变化
           * @description 更新选中的行数据和行ID数组
           * @param {Array} selection - 选中的行数据数组
           */
        handleSelectionChange(selection) {
            this.selectedRowKeys = selection.map(row => row.id)
            this.selectedRows = selection
        },
        /**
           * 查看套餐详情
           * @description 点击二维码名称时触发，获取并显示套餐的详细信息
           * @param {Object} row - 选中的套餐行数据
           * @returns {Promise<void>}
           */
        async handleViewPackageDetail(row) {
            try {
                // 重置状态
                this.qrCodeUrl = '';
                // 保存当前二维码的名称，用于下载时使用
                this.qrCodeName = row.name || '二维码';
                // 打开二维码弹窗
                this.qrCodeDialogVisible = true;
                // 延迟执行，确保DOM已经渲染完成
                setTimeout(() => {
                    this.$nextTick(() => {
                        // 获取容器引用
                        const container = this.$refs.qrcodeContainer;
                        if (!container) {
                            this.$message.error('二维码容器未找到');
                            return;
                        }
                        // 强制清空容器
                        container.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;">生成中...</div>';
                        // 创建URL，确保使用https协议
                        const qrUrl = `https://city.joinstech.com:8000/rt_qr/?id=${row.id}`;
                        // 使用qrcode插件生成二维码
                        this.generateQRCodeWithPlugin(container, qrUrl);
                    });
                }, 50); // 稍微延迟确保弹窗完全渲染
            } catch (error) {
                this.$message.error('生成二维码失败');
            }
        },
        /**
         * 使用qrcode插件生成二维码
         * @description 使用qrcode.js库生成二维码
         * @param {HTMLElement} container - 二维码容器
         * @param {string} qrUrl - 二维码内容URL
         */
        async generateQRCodeWithPlugin(container, qrUrl) {
            try {
                // 清空容器
                container.innerHTML = '';
                // 创建canvas元素
                const canvas = document.createElement('canvas');
                canvas.width = 200;
                canvas.height = 200;
                container.appendChild(canvas);
                // 使用qrcode库生成二维码
                await QRCode.toCanvas(canvas, qrUrl, {
                    width: 200,
                    margin: 1,
                    color: {
                        dark: '#000000',
                        light: '#ffffff'
                    }
                });
                // 获取data URL用于下载
                this.qrCodeUrl = canvas.toDataURL('image/png');
            } catch (error) {
                this.$message.error('二维码生成失败，请稍后重试');
            }
        },
        /**
         * 下载二维码图片
         * @description 将二维码图片下载到本地
         */
        handleDownloadQrCode() {
            try {
                // 检查是否有二维码URL
                if (!this.qrCodeUrl) {
                    this.$message.warning('二维码尚未生成，请稍后重试');
                    return
                }
                // 创建临时a标签用于下载
                const a = document.createElement('a');
                // 设置下载属性和文件名
                a.download = `${this.qrCodeName}.png`;
                // 如果是本地生成的二维码（data URL），直接使用
                // 如果是远程URL，先下载到Blob再创建URL
                if (this.qrCodeUrl.startsWith('data:')) {
                    a.href = this.qrCodeUrl;
                    this.performDownload(a);
                } else {
                    // 对于远程URL，先获取Blob
                    fetch(this.qrCodeUrl)
                        .then(response => response.blob())
                        .then(blob => {
                            a.href = URL.createObjectURL(blob);
                            this.performDownload(a);
                            // 清理URL对象
                            setTimeout(() => URL.revokeObjectURL(a.href), 100);
                        })
                        .catch(err => {
                            console.log('code.vue ~ line: 483 ~ err ->', err);
                            this.$message.error('下载失败，请稍后重试');
                        });
                }
            } catch (error) {
                this.$message.error('下载失败');
            }
        },
        /**
         * 执行下载操作
         * @description 处理a标签的点击和清理
         * @param {HTMLAnchorElement} a - 用于下载的a标签
         */
        performDownload(a) {
            // 添加到DOM并触发点击
            document.body.appendChild(a);
            a.click();
            // 移除元素
            document.body.removeChild(a);
            // 显示成功消息
            this.$message.success('二维码下载成功');
        },
        /**
         * 在新标签页中打开二维码
         * @description 在浏览器新标签页中打开二维码图片
         */
        handleOpenQrCodeInNewTab() {
            try {
                // 检查是否有二维码URL
                if (!this.qrCodeUrl) {
                    this.$message.warning('二维码尚未生成，请稍后重试');
                    return;
                }
                // 对于data URL，先创建一个临时链接
                if (this.qrCodeUrl.startsWith('data:')) {
                    const newWindow = window.open('', '_blank');
                    if (newWindow) {
                        newWindow.document.write(`<html><head><title>${this.qrCodeName}</title></head><body style="display:flex;justify-content:center;align-items:center;height:100vh;margin:0;"><img src="${this.qrCodeUrl}" alt="二维码" style="max-width:90%;max-height:90%;"></body></html>`);
                        newWindow.document.close();
                    } else {
                        this.$message.error('无法打开新窗口，请检查浏览器设置');
                    }
                } else {
                    // 对于远程URL，直接打开
                    window.open(this.qrCodeUrl, '_blank');
                }
            } catch (error) {
                this.$message.error('打开失败');
            }
        },
        /**
           * 启用套餐
           * @description 将套餐状态从停用改为启用
           * @param {Object} row - 要启用的套餐行数据
           * @returns {Promise<void>}
           */
        async handleEnable(row) {
            this.$confirm('确定要启用该套餐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const params = {
                        id: row.id,
                        status: 2
                    }
                    await startOrStopQrCode(params)
                    this.$message({
                        type: 'success',
                        message: '启用成功'
                    })
                    // 刷新当前页数据
                    this.loadData()
                } catch (error) {
                    this.$message.error('启用失败')
                }
            }).catch(() => { })
        },
        /**
           * 停用套餐
           * @description 将套餐状态从启用改为停用
           * @param {Object} row - 要停用的套餐行数据
           * @returns {Promise<void>}
           */
        async handleDisable(row) {
            this.$confirm('确定要停用该套餐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const params = {
                        id: row.id,
                        status: 1
                    }
                    await startOrStopQrCode(params)
                    this.$message({
                        type: 'success',
                        message: '停用成功'
                    })
                    // 刷新当前页数据
                    this.loadData()
                } catch (error) {
                    this.$message.error('停用失败')
                }
            }).catch(() => { })
        },
        /**
         * 删除编辑表单中的文件
         */
        handleDeleteEditFile(row, index) {
            this.$confirm('确定要删除该套餐吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 从文件列表中删除
                this.editForm.comboList.splice(index, 1);
                this.$message.success('删除成功');
            }).catch(() => { });
        },
        /**
         * 处理排序值变化
         * @description 当用户修改排序值时，根据新的排序值重新排序套餐列表
         * @param {Object} row - 当前修改的套餐行数据
         * @param {number} index - 当前套餐的索引
         */
        handleSortChange(row) {
            // 确保排序值是有效的数字
            if (row.sort === null || row.sort === undefined || isNaN(row.sort)) {
                row.sort = 1;
            }
            // 根据sort字段对列表进行重新排序
            this.editForm.comboList.sort((a, b) => {
                // 如果sort未定义，默认为0
                const sortA = a.sort || 0;
                const sortB = b.sort || 0;
                return sortA - sortB;
            });
            // 触发视图更新
            this.editForm.comboList = [...this.editForm.comboList];
        },
        /**
         * 编辑套餐
         * @description 打开编辑弹窗并填充当前套餐数据
         * @param {Object} row - 要编辑的套餐行数据
         */
        handleEdit(row) {
            // 获取套餐详情，确保包含图片信息
            this.getPackageDetailForEdit(row.id);
        },
        /**
         * 获取套餐详情用于编辑
         * @description 获取套餐详情并处理图片数据
         * @param {number} id - 套餐ID
         */
        async getPackageDetailForEdit(id) {
            try {
                const res = await getQrCodeDetail(id);
                const detail = JSON.parse(res.data);
                // 处理comboList字段，确保数据格式正确
                let comboList = [];
                if (detail.comboList && Array.isArray(detail.comboList)) {
                    comboList = detail.comboList.map((item, index) => ({
                        ...item,
                        comboName: item.comboName || item.name,
                        // 如果没有sort字段，默认按索引+1设置排序值
                        sort: item.sort || (index + 1)
                    }));
                }
                // 填充编辑表单数据
                this.editForm = {
                    ...detail,
                    comboList: comboList
                };
                // 打开编辑弹窗
                this.editDialogVisible = true;
            } catch (error) {
                this.$message.error('获取套餐详情失败');
            }
        },
        /**
           * 提交编辑
           * @description 验证表单并提交编辑后的套餐数据
           * @returns {Promise<void>}
           */
        async submitEdit() {
            this.$refs.editFormRef.validate(async (valid) => {
                if (valid) {
                    try {
                        // 按照指定的数据结构处理提交数据
                        const submitData = {
                            ...this.editForm,
                        };
                        await updateQrCode(submitData);
                        this.$message.success('编辑成功');
                        this.editDialogVisible = false;
                        this.loadData();
                    } catch (error) {
                        this.$message.error('编辑失败');
                    }
                }
            });
        },
        /**
           * 删除套餐
           * @description 确认后删除指定的套餐
           * @param {Object} row - 要删除的套餐行数据
           * @returns {Promise<void>}
           */
        async handleDelete(row) {
            // 判断是单条删除还是批量删除
            const isBatchDelete = !row.id;
            const ids = isBatchDelete ? this.selectedRowKeys : [row.id];
            // 根据删除类型显示不同的确认信息
            const confirmMessage = isBatchDelete 
                ? `确定要删除选中的 ${ids.length} 个套餐吗？` 
                : '确定要删除该套餐吗？';
            this.$confirm(confirmMessage, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    // 执行删除操作（批量或单条）
                    await deleteQrCode(ids.join(','));
                    this.$message({
                        type: 'success',
                        message: isBatchDelete ? `成功删除 ${ids.length} 个套餐` : '删除成功'
                    });
                    // 清空选中状态（批量删除时）
                    if (isBatchDelete) {
                        this.selectedRowKeys = [];
                        this.selectedRows = [];
                    }
                    // 重新加载数据
                    this.loadData();
                } catch (error) {
                    this.$message.error('删除失败');
                }
            }).catch(() => { })
        },
        /**
         * 处理选择套餐后的确认操作
         * @description 将选择的套餐添加到编辑表单中
         */
        handleConfirmAddPackage() {
            // 将选择的套餐添加到编辑表单的comboList中
            if (this.addForm.comboIds && this.addForm.comboIds.length > 0) {
                // 获取已存在的套餐ID列表，用于防止重复添加
                const existingIds = this.editForm.comboList.map(item => item.comboId);
                // 找出当前最大的排序值
                let maxSort = 0;
                this.editForm.comboList.forEach(item => {
                    if (item.sort && item.sort > maxSort) {
                        maxSort = item.sort;
                    }
                });
                // 只添加用户选择的且未重复的套餐
                this.addForm.comboIds.forEach(comboId => {
                    if (!existingIds.includes(comboId)) {
                        const selectedPackage = this.packageList.find(pkg => pkg.id === comboId);
                        if (selectedPackage) {
                            maxSort++;
                            this.editForm.comboList.push({
                                comboId: selectedPackage.id,
                                comboName: selectedPackage.name || selectedPackage.comboName,
                                sort: maxSort // 新添加的套餐使用新的排序值
                            });
                        }
                    }
                });
                // 清空addForm中的选择
                this.addForm.comboIds = [];
            }
            // 关闭选择套餐弹窗
            this.addDialogVisible = false;
        },
        /**
         * 处理选择套餐后的取消操作
         * @description 关闭选择套餐弹窗并清空选择
         */
        handleCancelAddPackage() {
            // 清空选择
            this.addForm.comboIds = [];
            this.addDialogVisible = false;
        }
    },
}
</script>
<style scoped>
.hvac-package-container {
    padding: 20px;
    background-color: #fff;
}
/* 操作按钮区域样式 */
.action-container {
    margin: 10px 0;
    border-radius: 4px;
    display: flex;
    gap: 10px;
    align-items: center;
}
/* 按钮样式增强 */
:deep(.action-container .el-button) {
    margin-right: 10px;
}
.search-container {
    padding: 10px;
    border-radius: 4px;
}
.table-container {
    margin-bottom: 20px;
}
.switch-type {
    margin-bottom: 20px;
    border-bottom: 1px solid #e4e7ed;
}
.switch-type>>>.el-radio-group {
    display: inline-flex;
}
.switch-type>>>.el-radio-button:first-child .el-radio-button__inner {
    border-radius: 4px 0 0 4px;
}
.switch-type>>>.el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 4px 4px 0;
}
.pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}
.package-name-link {
    color: #409EFF;
    cursor: pointer;
}
.package-name-link:hover {
    text-decoration: underline;
}
.qr-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
}
.qr-code-image {
    width: 200px;
    height: 200px;
    margin-bottom: 20px;
}
.qr-code-tip {
    text-align: center;
    color: #606266;
}
.qr-code-loading {
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    border-radius: 4px;
    color: #909399;
    font-size: 14px;
}
</style>